import { rootApi } from '../rootApi';

export const warrantyDashboardApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getWarrantyDashboard: builder.query({
            query: () => {
                return {
                    url: `v1/warrantydashboard/getwarrantydashboard`,
                    method: 'GET'
                };
            },
            providesTags: ['WarrantyDashboard']
        })
    })
});

export const { useGetWarrantyDashboardQuery } = warrantyDashboardApi;

